var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B92E2A",
    fillRule: "evenodd",
    d: "M12 4c-4.408 0-8 3.592-8 8 0 4.408 3.592 8 8 8 4.408 0 8-3.592 8-8 0-4.408-3.592-8-8-8zm.8 4.8c0-.442-.358-.8-.8-.8-.442 0-.8.358-.8.8v2.4H8.8c-.442 0-.8.358-.8.8 0 .442.358.8.8.8h2.4v2.4c0 .442.358.8.8.8.442 0 .8-.358.8-.8v-2.4h2.4c.442 0 .8-.358.8-.8 0-.442-.358-.8-.8-.8h-2.4V8.8zM5.6 12c0 3.528 2.872 6.4 6.4 6.4 3.528 0 6.4-2.872 6.4-6.4 0-3.528-2.872-6.4-6.4-6.4-3.528 0-6.4 2.872-6.4 6.4z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default ForwardRef;